import { ButtonProps as AntButtonProps } from 'antd';
import clsx from 'clsx';
import { AntButton } from 'components/ant/AntButton/AntButton';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

import s from './LinkStyled.module.less';

export const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>((props, ref) => {
  const { className, ...rest } = props;

  return <RouterLink {...rest} ref={ref} className={clsx(s.link, className)} />;
});

Link.displayName = 'Link';

interface LinkAlikeProps extends React.HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

export const LinkAlike = React.forwardRef<HTMLDivElement, LinkAlikeProps>((props, ref) => {
  const { isActive, className, children, ...rest } = props;

  return (
    <div {...rest} ref={ref} className={clsx(s.linkAlike, className, { [s.active]: isActive })}>
      {children}
    </div>
  );
});

LinkAlike.displayName = 'LinkAlike';

export const LinkButton = React.forwardRef<HTMLButtonElement, AntButtonProps>((props, ref) => {
  const { className, ...rest } = props;

  return <AntButton {...rest} ref={ref} className={clsx(s.linkButton, className)} />;
});

LinkButton.displayName = 'LinkButton';

export const RightActionsBlock = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  (props, ref) => {
    const { className, children, ...rest } = props;

    return (
      <div {...rest} ref={ref} className={clsx(s.rightActionsBlock, className)}>
        {children}
      </div>
    );
  },
);

RightActionsBlock.displayName = 'RightActionsBlock';
